import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '@shared/components/utils/hoc/withAnimation';

const CardVerticalButtonContainer = styled.div<{
  color?: string;
  focused?: boolean;
}>`
  align-items: center;
  background: ${(props) => {
    return props?.focused ? '#FFFFFFCC' : '#090909CC';
  }};
  border: ${(props) => {
      return props?.focused ? '#09090933' : props?.color || '#FFFFFF';
    }}
    solid ${2 * Screen.widthRatio}px;
  border-radius: ${20 * Screen.widthRatio}px;
  color: ${(props) => (props.focused ? '#000000' : '#FFFFFF')};
  display: flex;
  justify-content: space-between;
  font-family: ${Fonts['regular']};
  font-size: ${16 * Screen.widthRatio}px;
  height: ${30 * Screen.widthRatio}px;
  padding: 0 ${8 * Screen.widthRatio}px;
  width: ${168 * Screen.widthRatio}px;
`;

export default withAnimation(CardVerticalButtonContainer);
